var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.youtube || _vm.video.length
    ? _c(
        "div",
        { class: ["video-box", { "video-box--is-play": _vm.isPlay }] },
        [
          _vm.video.length
            ? _c(
                "video",
                {
                  ref: "video",
                  staticClass: "video-box__element",
                  attrs: { controls: "" }
                },
                _vm._l(_vm.video, function(item) {
                  return _c("source", {
                    attrs: { src: item.src, type: item.type }
                  })
                }),
                0
              )
            : _vm._e(),
          _vm.youtube && _vm.isPlay
            ? _c("iframe", {
                staticClass: "video-box__element",
                attrs: {
                  src: _vm.youtube + "?autoplay=1",
                  frameborder: "0",
                  allow: "autoplay; encrypted-media",
                  allowfullscreen: ""
                }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "video-box__poster",
              style: { "background-image": "url(" + _vm.poster + ")" },
              on: { click: _vm.play }
            },
            [
              _c("div", { staticClass: "video-box__play" }, [
                _c(
                  "svg",
                  {
                    staticClass: "video-box__play-icon",
                    attrs: { width: "33", height: "36", viewBox: "0 0 33 36" }
                  },
                  [_c("path", { attrs: { d: "M3 .6v34.7L32.9 18z" } })]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b53308aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b53308aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/VideoBox.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b53308aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/VideoBox.vue
// module chunks = 1 2